<template>
  <b-container
    class="vh-100 d-flex justify-content-center align-items-center flex-column background px-0 mx-0"
    fluid
  >
    <div
      class="signin-container bg-light p-3"
      style="border-radius: 24px;"
    >
      <div class="signin-content d-flex flex-column align-items-center">

        <div class="d-flex flex-column justify-content-start w-100">
          <div class="d-flex justify-content-end">
            <!-- <BPopover
              target="theme-mode-toggler"
              triggers="hover"
              placement="auto"
              class="rounded-lg"
            >
              Toggling between light and dark mode.
            </BPopover> -->
          </div>
          <div class="d-flex flex-column align-items-center mb-3 mt-1">
            <div class="d-flex flex-column align-items-center">
              <h3 style="font-weight: 900;">
                <span class="text-primary">IFAS</span>
              </h3>
              <h6
                class="text-center"
                style="font-size: 14px; font-weight: 500; color: #999;"
              >
                Integrated Finance Accounting System
              </h6>
            </div>
          </div>
        </div>

        <div class="signin-form">
          <ValidationObserver
            ref="signinForm"
            v-slot="{ handleSubmit }"
          >
            <form
              role="form"
              novalidate
              @submit.prevent="handleSubmit(onSignIn)"
            >
              <div
                class="rounded py-2 px-2"
              >
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <b-row>
                      <b-col
                        cols="12"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="username"
                          name="username"
                          rules="required"
                        >
                          <BFormGroup
                            label="Username"
                            label-for="username"
                            label-class="font-weight-bold"
                            class="mb-2"
                          >
                            <b-form-input
                              id="username"
                              v-model="credentials.username"
                              type="text"
                              size="sm"
                              placeholder="enter username here"
                              autocomplete="off"
                              :state="errors.length > 0 ? false : null"
                              :disabled="state.busy"
                            />
                            <div
                              v-if="errors.length > 0"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </b-col>

                      <b-col
                        cols="12"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="password"
                          name="password"
                          rules="required"
                        >
                          <b-form-group
                            label="Password"
                            label-for="password"
                            label-class="font-weight-bold"
                            class="mb-2"
                          >
                            <b-input-group
                              :class="errors.length > 0 ? 'is-invalid' : ''"
                            >
                              <b-form-input
                                id="password"
                                v-model="credentials.password"
                                size="sm"
                                placeholder="enter password here"
                                autocomplete="off"
                                :type="passwordType"
                                :state="errors.length > 0 ? false : null"
                                :disabled="state.busy"
                              />
                              <b-input-group-append>
                                <b-button
                                  class="pl-2 pr-0 text-dark input-icon"
                                  variant="light"
                                  :disabled="state.busy"
                                  @click.prevent="togglePassword"
                                >
                                  <i
                                    v-if="state.visible_password"
                                    class="fad fa-eye h6 mb-0 min-w-40px"
                                  />
                                  <i
                                    v-else
                                    class="fad fa-eye-slash h6 mb-0 min-w-40px"
                                  />
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <div
                              v-if="errors.length > 0"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="px-2 pt-2">

                  <b-col
                    cols="12"
                    class="px-1"
                  >
                    <b-overlay
                      rounded
                      opacity="0.1"
                      spinner-variant="secondary"
                      spinner-small
                      :show="state.local"
                    >
                      <b-button
                        size="sm"
                        type="submit"
                        class="w-100 font-weight-bolder"
                        variant="primary"
                        :disabled="state.busy"
                      >
                        Sign In
                      </b-button>
                    </b-overlay>
                  </b-col>

                  <b-col class="text-divider">
                    <span>&nbsp; or sign in with</span>
                  </b-col>

                  <b-col
                    cols="12"
                    class="px-1"
                  >
                    <b-overlay
                      rounded
                      opacity="0.1"
                      spinner-variant="primary"
                      spinner-small
                      :show="state.sso"
                    >
                      <b-button
                        size="sm"
                        type="button"
                        class="w-100 font-weight-bolder"
                        variant="secondary"
                        :disabled="state.busy"
                        @click.prevent="onSignInWithAljaySSO"
                      >
                        Aljay SSO
                      </b-button>
                    </b-overlay>
                  </b-col>
                </b-row>
              </div>

            </form>
          </ValidationObserver>
        </div>
      </div>

    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Oauth2 } from 'universal-social-auth'

import { SSharedAuth, SSharedSSO } from '@/services'

export default {
  name: 'VSharedSignIn',

  middleware: ['guest'],

  metaInfo: () => ({
    title: 'Sign In'
  }),

  data: () => ({
    state: {
      busy: false,
      local: false,
      sso: false,
      visible_password: false
    },
    credentials: {
      username: '',
      password: ''
    },
    singleSignOn: Oauth2
  }),

  computed: {
    ...mapGetters({
      darkMode: 'settings/darkModeState',
      user: 'auth/user'
    }),

    passwordType () {
      return this.state.visible_password ? 'text' : 'password'
    }

  },

  methods: {

    togglePassword () {
      this.state.visible_password = !this.state.visible_password
    },

    async saveAndGetCurrentUser (token) {
      this.$store.dispatch('auth/saveToken', token)

      return new Promise((resolve, reject) => {
        SSharedAuth.getCurrentUser().then(
          ({ data }) => {
            this.$store.dispatch('auth/fetchUserSuccess', {
              id: data.id,
              email: data.email,
              role: data.role.code,
              role_name: data.role.name,
              username: data.role.username,
              name: data.name,
              budget: data.budget,
              is_approver: data.is_approver
            })

            const user = this.$store.getters['auth/user']

            if (this.$route.query.redirect) {
              this.$router.replace(this.$route.query.redirect)
            } else {
              this.$router.replace({
                name: user ? `${user.role}.dashboard` : 'dashboard'
              }, () => {
                resolve(data)
              })
            }
          }
        ).catch(error => {
          this.$store.dispatch('auth/fetchUserFailure')
          reject(error)
        })
      })
    },

    async onSignIn () {
      await this.$refs.signinForm.validate().then(
        allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.state.busy = this.state.local = true
            SSharedAuth.signIn(this.credentials).then(
              ({ data: { token } }) => {
                this.saveAndGetCurrentUser(token).finally(() => {
                  this.state.busy = this.state.local = false
                })
              }
            ).catch(() => {
              this.state.busy = this.state.local = false
            })
          }
        }
      )
    },

    async onSignInWithAljaySSO (event) {
      event.preventDefault()
      this.state.busy = this.state.sso = true
      this.$usAuth.authenticate('oauth2', this.singleSignOn).then(
        authorized => {
          SSharedSSO.post(authorized).then(
            ({ data: { token } }) => {
              this.saveAndGetCurrentUser(token).finally(() => {
                this.state.busy = this.state.local = false
              })
            }
          ).catch(() => {
            this.state.busy = this.state.sso = false
          })
        }
      )
    },

    darkChange (mode) {
      this.modeChange({ rtl: false, dark: mode })
    },

    ...mapActions({
      modeChange: 'settings/layoutModeAction'
    })
  }
}
</script>

<style scoped lang="scss">
  .signin-container {
    max-width: 85vw;
    box-shadow: 0px 0px 5px 0px var(--iq-primary-light);
    border: 1px solid var(--iq-primary-light);
  }

  .dark .signin-container {
    box-shadow: 0px 0px 5px 0px var(--iq-primary-light);
    border: 1px solid var(--iq-primary-dark);
  }

  .background {
    /*
     * Rice field with tree image featuring:
     * - Clouds: #F9F8F1
     * - Sky: #00A5FE
     * - Rice field: #58DC00 and #005032
     */
    background: var(--iq-body-bg);
    background-image:
      linear-gradient(135deg, rgba(255, 255, 255, 0.25), rgba(248, 250, 248, 0.25)),
      url('../../assets/images/background.png');
    background-size: cover;
    background-position: top right;
    background-attachment: fixed;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 768px) {
    .signin-container {
      max-width: 375px;
    }

    .background {
      background-position: center;
    }
  }

  @media screen and (orientation: landscape) and (min-width: 576px) and (max-height: 430px) {
    .signin-container {
      max-width: 85vw;
      .signin-content {
        flex-direction: row !important;
        gap: 2rem;
        .signin-form {
          max-width: 300px;
        }
      }
    }
  }

  // .dark .background {
  //   background-image:
  //     linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15)),
  //     url('../../assets/images/background-dark.png');
  // }

  .text-divider {
    margin: 2em 0;
    line-height: 0;
    text-align: center;
    color: gray;
    padding: 0px 5px;
  }
  .text-divider span {
    background-color: rgb(255, 255, 255);
    padding: 0 0.5em;
  }
  .text-divider:before {
    content: " ";
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid rgb(194, 192, 192);
    border-bottom: 1px solid #f7f7f7;
  }
  .text-divider span:before  {
    content: "";
    display: block;
    margin-top: -3px;
  }
  .text-divider span:after  {
    display: block;
    margin-top: -3px;
  }
  .dark {
    .text-divider {
      color: var(--iq-light);
    }
    .text-divider span {
      background-color: var(--iq-dark-card-bg);
    }
    .text-divider:before {
      border-top: 1px solid var(--iq-light);
      border-bottom: 1px solid var(--iq-dark-card-bg);
    }
  }
</style>
